import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Balance } from '@app/features/balance/components/balance/balance';
import { GameNotificationService } from '@app/services/game-notification/game-notification';

@Component({
  selector: 'bingo-header',
  imports: [
    RouterLink,
    NgOptimizedImage,
    RouterLinkActive,
    Balance,
    MatIcon,
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  protected readonly gameNotification = inject(GameNotificationService);
}
